import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  id_customers_reservation_event_zone: '',
  seconds_to_expire: 0,
  cart_loading: true,
}

export const sessionCustomerSlice = createSlice({
  name: 'session-customer-storage',
  initialState: initialState,
  reducers: {
    setSessionCustomer: (state, action) => {
      state.id_customers_reservation_event_zone = action.payload.id_customers_reservation_event_zone
      localStorage.setItem('session-customer-storage', action.payload.id_customers_reservation_event_zone);
    },
    setSecondToExpire: (state, action) => {
      state.seconds_to_expire = action.payload.seconds_to_expire
      state.cart_loading = false
    },
  }
});

export const { setSessionCustomer, setSecondToExpire } = sessionCustomerSlice.actions;